import { render, staticRenderFns } from "./calendar-view-table.vue?vue&type=template&id=5882533e&scoped=true"
import script from "./calendar-view-table.vue?vue&type=script&setup=true&lang=js"
export * from "./calendar-view-table.vue?vue&type=script&setup=true&lang=js"
import style0 from "./calendar-view-table.vue?vue&type=style&index=0&id=5882533e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5882533e",
  null
  
)

export default component.exports